import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const awards = [
    { image: '/award-diamond.png', title: 'Diamond Award', subtitle: '2026' },
    { image: '/award-customer-service.png', title: 'Top 10 Service', subtitle: 'Front Runner' },
    { image: '/award-five-star.png', title: 'Five Star Energy', subtitle: 'Brick, Inc' }
  ];

  return (
    <footer className="footer" data-testid="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <img
              src="https://customer-assets.emergentagent.com/job_0e33f67c-8e2b-40b5-8e43-a87d8ad0485f/artifacts/j7xc6nbc_Image%2B%281%29.png.webp"
              alt="Last Mile Advisors"
              className="footer-logo"
            />
            <p className="footer-text mt-4">
              Independent energy and utility cost advisory for commercial, industrial, and residential clients.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <nav className="footer-nav">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/services" className="footer-link">Services</Link>
              <Link to="/market-map" className="footer-link">Market Map</Link>
              <Link to="/about" className="footer-link">About</Link>
              <Link to="/blog" className="footer-link">Blog</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <nav className="footer-nav">
              <Link to="/services" className="footer-link">Utility Rate Analysis</Link>
              <Link to="/services" className="footer-link">Energy Cost Optimization</Link>
              <Link to="/services" className="footer-link">Regulatory Review</Link>
              <Link to="/services" className="footer-link">Strategic Advisory</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact</h4>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <Phone size={16} className="footer-icon" />
                <a href="tel:+16122763255" className="footer-link" data-testid="footer-phone-link">
                  612-276-3255
                </a>
              </div>
              <div className="footer-contact-item">
                <Mail size={16} className="footer-icon" />
                <a href="mailto:sales@lastmileadvisors.com" className="footer-link">
                  sales@lastmileadvisors.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Awards in Footer */}
        <div className="footer-awards" data-testid="footer-awards">
          <div className="footer-awards-grid">
            {awards.map((award, index) => (
              <div key={index} className="footer-award">
                <img src={award.image} alt={award.title} />
                <div className="footer-award-text">
                  <span>{award.title}</span>
                  <span>{award.subtitle}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {currentYear} Last Mile Advisors. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
